<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHandleInternal from "../DesignerQuestionHardwareHandleInternal.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHandleInternal
        ],
        computed: {
            panel_required(){
                return this.filtered_option_list.length > 1;
            },
        },
    }
</script>
